export default {
    contractEditHeader: {
        backToBinEditor: 'Nazaj na urejevalnik košar',
        loadError: 'Pogodbe ni bilo mogoče naložiti',
    },
}
